import { Component, OnInit, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { GlobalComponent } from "../../global/global.component";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { FilterSettingsModel, IFilter, GridComponent, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { UsersHttpService } from './users.service';
import { sortingObj, functionpermission, GetUserListBo, WhereCondition, UserBO } from './users.model';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { ColumnChangeBO, columnWidth } from '../list/list.model';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { GetHTTPService } from './user-table.service';
import { GeneralService } from 'src/app/service/general.service';
import { ErrorService } from 'src/app/error.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  // ========Main Initialization=================//
  User: UserBO = new UserBO();
  RoleBySuperAdmin: Boolean = false;
  UserArray: UserBO[];
  RoleType: string = "";
  RoleTypeUpdate: string = "";
  isInternalRole: boolean = false;
  isSuperAdmin: boolean = false;
  usergridArray = [];
  StatusDrop = [];
  EmpList = [];
  UsersendBO: GetUserListBo = new GetUserListBo();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();

  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string = "00000000-0000-0000-0000-000000000000";
  arraycol: any = [];

  locationList: any = [];

  // ============Form Initialization====================//

  resetPass: FormGroup;

  userForm = new FormGroup({
    FirstName: new FormControl('', [Validators.required]),
    MiddleName: new FormControl(''),
    LastName: new FormControl('', [Validators.required]),
    Status: new FormControl('', [Validators.required]),
    Role: new FormControl('', [Validators.required]),
    Email: new FormControl('', [Validators.required, Validators.email]),
    Phone1: new FormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
    Phone2: new FormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
    UserName: new FormControl('', [Validators.required]),
    Password: new FormControl('', [Validators.required]),
    Location: new FormControl(''),
    ExcludeIpRestrict: new FormControl(''),
    // ,Validators.pattern('[A-Z][a-z]'),Validators.minLength(8)]
  });

  UpdateForm = new FormGroup({
    id: new FormControl(''),
    FirstNameUpdate: new FormControl('', [Validators.required]),
    MiddleNameUpdate: new FormControl(''),
    LastNameUpdate: new FormControl('', [Validators.required]),
    StatusUpdate: new FormControl('', [Validators.required]),
    RoleUpdate: new FormControl('', [Validators.required]),
    // LocationUpdate: new FormControl(''),
    EmailUpdate: new FormControl('', [Validators.required, Validators.email]),
    Phone1Update: new FormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
    Phone2Update: new FormControl('', [Validators.minLength(14), Validators.maxLength(14)]),
    Username: new FormControl(''),
    ExcludeIpRestrict: new FormControl('')
  });

  RoleUpdateForm = new FormGroup({
    id: new FormControl(''),
    UserUpdateEmployee: new FormControl('', [Validators.required]),
    UserUpdateStatus: new FormControl('', [Validators.required]),
    UserUpdateRole: new FormControl('', [Validators.required]),
  });

  // ==========Filters=================//

  SearchText: string = '';
  SearchColumn: string = "username";

  // =========Table Initialization=============//

  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  initialPage: object;
  filterOptions: FilterSettingsModel;
  // grid: GridComponent;
  @ViewChild('grid') public grid: GridComponent;
  filter: IFilter;
  TotalCount: number;
  pagshort: sortingObj = new sortingObj();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  //============================Data manager===============================//
  public isinitialLoad: boolean = false;
  UserPhone1: string;
  UserPhone2: string;
  // ===================================Other initialization===================//
  //======================================new try====================//
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;

  // ===============Functionality Initializatin==============//
  statusList: any = []

  valuechange: any = [];
  roleName = [];
  userLocation = [];
  formvalue = [];
  dropdownSettings = {};
  ResetPassword: string;
  UserId: string;
  UserRole: any
  passerror: boolean = false;
  ModelType: string = 'edit';
  fp: functionpermission = new functionpermission();
  IsButtonDisable: boolean = false;

  constructor(private formBuilder: FormBuilder, @Inject(GetHTTPService) public gethttp: GetHTTPService, public global: GlobalComponent, public httpService: UsersHttpService, private ref: ChangeDetectorRef, public toastrService: ToastrService, public general: GeneralService, public errorService: ErrorService,
    public ClientService: ClientHttpService, private http: HttpClient,) {
    this.global.checkforlogout();
    this.data = gethttp;
    this.resetPass = this.formBuilder.group({
      Password: ['', Validators.required]
    });

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'label',
      text: "Select",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "myclass custom-class",
      "allowSearchFilter": true
    };
  }
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.UsersendBO.orderColumn = state.sorted[0].name;
        this.UsersendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.UsersendBO.field = state.action.currentFilterObject.field;
      this.UsersendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.UsersendBO.operator = state.action.currentFilterObject.operator;
      this.UsersendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.UsersendBO.field = "name";
        this.UsersendBO.matchCase = false;
        this.UsersendBO.operator = "contains";
        this.UsersendBO.value = "";
      }
    }
    this.GetUser();

    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Import.Pagesize != state.take) {
          this.arraycol[0].Import.Pagesize = state.take
        }

      }
    }

  }

  ngOnInit() {
    if (this.global.agencyCode.toUpperCase() == 'SUPERADMIN' && (this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000' ||
      this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined)) {
      this.RoleType = "SuperAdminRole";
    } else if (this.global.agencyCode.toUpperCase() == 'SUPERADMIN' && (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000' &&
      this.global.globalAgencyId != null && this.global.globalAgencyId != '')) {
      this.RoleType = "Internal";
    }
    else if (this.global.agencyCode.toUpperCase() != 'SUPERADMIN') {
      this.RoleType = "Internal";
    }

    this.RoleTypeChange()
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.fp = new functionpermission();
    this.SearchText = "";

    this.filterOptions = { type: 'Menu' };
    let pag = 10
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };
    this.UsersendBO.currentpageno = 1;
    this.UsersendBO.pageitem = pag;

    this.GetUser();
    this.getStatus()
    setTimeout(() => {
      this.initData();
    }, 2000);
    this.getLocation();

    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "user");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  onActionBegin(args) {

  }
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })

      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        if (this.arraycol.length > 0) {
          this.arraycol[0].Users.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });

          });

          this.arraycol[0].Users.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });

          });


          if (this.arraycol[0].Users.ShowColumns.length != count1 || this.arraycol[0].Users.HideColumns.length != count) {
            this.arraycol[0].Users.ShowColumns = showarr;
            this.arraycol[0].Users.HideColumns = hidearr;
          }
        }

      }
    }

    this.UsersendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.UsersendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }

  // =======================Grid Column selector ================ //
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50);
  }
  // ===========================================//

  passvalid(event) {

    let str = event.target.value;
    let res;

    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str.length >= 8) {
      this.passerror = false;
    }
    else {
      this.passerror = true;
    }

  }

  Cancel__Click() {
    this.resetPass.reset();
    this.userForm.reset();
    this.UpdateForm.reset();
    this.RoleUpdateForm.reset();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  Refresh() {
    this.SearchText = "";
    this.UsersendBO.field = "name";
    this.UsersendBO.value = "";
    this.UsersendBO.currentpageno = 1;
    this.GetUser();
    this.initData();
    this.getStatus();
  }


  Search() {
    this.UsersendBO.value = this.SearchText;
    this.UsersendBO.currentpageno = 1;
    this.GetUser();
  }

  initData() {
    let myparams2 = new URLSearchParams();
    myparams2.append("isSuperAdmin", this.isSuperAdmin.toString());

    this.httpService.getUserLoginRoles(myparams2).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.UserRole = data;

    })

  }


  onSelectAll(event) {
  }
  onItemSelect(event) {
  }

  // ==========================popup check=====================================//
  popBool: boolean = false;
  onvalChange() {
    this.popBool = true;

  }
  // ==========================Send Data==================================== //

  UserCreateUpdate(type: string) {

    if (type == 'new') {
      this.roleName = [];
      this.userLocation = [];
      this.Cancel__Click();
      this.ModelType = "new";
      this.valueschanges();
      this.popBool = false;
      if (this.global.agencyCode.toUpperCase() == 'SUPERADMIN' && (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000' &&
        this.global.globalAgencyId != null && this.global.globalAgencyId != '')) {
        this.RoleType = "Internal";
      }
      else if (this.global.agencyCode.toUpperCase() != 'SUPERADMIN') {
        this.RoleType = "Internal";
      }

      this.RoleTypeChange()
    }
    else {
      this.ModelType = "edit";

    }
  }

  selectUserdetails(UserDetails: UserBO) {
    let roles = UserDetails.userRoleId.split(',');
    if (this.global.agencyCode.toUpperCase() == 'SUPERADMIN' && (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000' &&
      this.global.globalAgencyId != null && this.global.globalAgencyId != '')) {
      this.RoleTypeUpdate = "Internal";
    }
    else if (this.global.agencyCode.toUpperCase() != 'SUPERADMIN') {
      this.RoleTypeUpdate = "Internal";
    }
    this.RoleTypeChangeUpdate()
    this.RoleBySuperAdmin = false;

    this.roleName = UserDetails.userRoleId.split(",");
    let data: any = [];
    this.locationList.forEach(element => {
      UserDetails.locationIdList.forEach(ele => {
        if (element.Key == ele.locationId) {
          data.push(ele.locationId);
        }
      });
    });

    this.userLocation = data;
    this.User = JSON.parse(JSON.stringify(UserDetails));
    this.UserPhone1 = UserDetails.phone1;
    this.UserPhone2 = UserDetails.phone2;

    this.UpdateForm.controls.StatusUpdate.setValue(UserDetails.statusLid);
    this.popBool = false;
    this.valueschanges();
  }


  // ========================Fetch Data from API================================= //

  GetUser() {
    this.gethttp.execute(this.UsersendBO);
    let count = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      count = count + 1
      if (data != null && data != undefined && count == 1) {
      }
    })

  }

  gettotalCount() {

    let params = new URLSearchParams();
    params.append("SearchColumn", "C");
    params.append("SearchText", this.SearchText);

    this.httpService.gettotalCount(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.TotalCount = data;
    })
  }
  getStatus() {
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.httpService.getStatusList(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.statusList = JSON.parse(JSON.stringify(data));
      this.statusList.forEach((ele) => {
        ele.Key = ele.id
        ele.Value = ele.lovName;
      })
    })

  }
  // ==========================Save or update Data====================================== //

  deleteError: string = "";
  deleteAlert: boolean = false;
  statusValue: any;
  SaveOrUpdateUser() {
    this.IsButtonDisable = true;
    if (this.ModelType == 'new') {
      this.User.id = "00000000-0000-0000-0000-000000000000";
    }
    this.statusList.forEach(element => {
      if (element.Value == "InActive") {
        this.statusValue = element.Key;
      }
    });
    if (this.User.statusLid == this.statusValue) {
      this.User.isBlocked = true;
    } else {
      this.User.isBlocked = false;
    }
    this.User.phone1 = this.general.reconverPhoneGoogleLib(this.UserPhone1);
    this.User.phone2 = this.general.reconverPhoneGoogleLib(this.UserPhone2);
    this.User.statusLid = this.User.statusLid;
    this.User.roleName = this.roleName;

    this.User.excludeIprestric = this.User.excludeIprestric != null ? this.User.excludeIprestric : false;
    if (this.ModelType == 'new') {
      this.httpService.saveupdateUser(this.User).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.IsButtonDisable = false;
        if (data) {
          this.valueschanges();
          //====================== sucess message =============
          if (this.ModelType == 'new') {
            if (data) {
              this.toastrService.success(
                'User Saved successfully!',
                'User Saved'), 8000;
              this.User.id = data.id;
              this.userForm.reset();
              document.getElementById('OpenModal1').click();
              this.GetUser();
            }

          }

        }
      }, (err: any) => {
        this.IsButtonDisable = false;
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;
        }
      }
      )
    }
    if (this.ModelType == 'edit') {
      this.httpService.updateUser(this.User).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.IsButtonDisable = false;
        if (data) {
          this.valueschanges();
          //====================== sucess message =============
          this.toastrService.success(
            'User Updated successfully!',
            'User Updated'), 8000;

          this.UpdateForm.reset();
          document.getElementById('OpenModal2').click();
          this.GetUser();
        }
      }, (err: any) => {
        this.IsButtonDisable = false;
        if (err) {
          this.toastrService.error(err, 'Error'), 8000;

        }
      }
      )
    }

  }

  // ================================Reset Password========================== //

  resetpassword(userid) {
    this.UserId = userid;
  }

  ResetPasswrd(Status: string) {
    this.IsButtonDisable = true;
    var saveList: UserBO;
    let myParams = new URLSearchParams();
    myParams.append("Userid", this.UserId);
    myParams.append("password", this.ResetPassword);
    this.httpService.ResetPassword(myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      this.toastrService.success(
        'Password has been changed successfully!',
        'Password changed'), 8000;
      document.getElementById('resetmodal').click();
      document.getElementById('resetmodalConfirmation').click();
      this.resetPass.reset();
    }, ((err: any) => {
      this.IsButtonDisable = false;
    }))
  }


  // ====================================================================
  filepermissionget() {
    let params = new URLSearchParams();
    params.append("pagecode", "USERS");
    params.append("roleId", this.global.roleId);
    this.httpService.getFilePermissions(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: functionpermission) => {
      this.fp = data;
    });
  }

  // ================================================================================

  valueschanges() {
    this.valuechange = {
      Status: 0,
      FirstName: 0,
      MiddleName: 0,
      LastName: 0,
      RoleId: 0,
      Email: 0,
      Phone1: 0,
      Phone2: 0,
      UserName: 0,
      Password: 0,
    }
  }
  count: any = 0;
  checkpopup(value) {
    if (value == "Status") {
      this.valuechange.Status = this.valuechange.Status + 1;
    }
    if (value == "FirstName") {
      this.valuechange.FirstName = this.valuechange.FirstName + 1;
    }
    if (value == "MiddleName") {
      this.valuechange.MiddleName = this.valuechange.MiddleName + 1;
    }
    if (value == "LastName") {
      this.valuechange.LastName = this.valuechange.LastName + 1;
    }
    if (value == "RoleId") {
      this.valuechange.RoleId = this.valuechange.RoleId + 1;
    }
    if (value == "Email") {
      this.valuechange.Email = this.valuechange.Email + 1;
    } if (value == "Phone1") {
      this.valuechange.Phone1 = this.valuechange.Phone1 + 1;
    }
    if (value == "Phone2") {
      this.valuechange.Phone2 = this.valuechange.Phone2 + 1;
    }
    if (value == "UserName") {
      this.valuechange.UserName = this.valuechange.UserName + 1;
    }
    if (value == "Password") {
      this.valuechange.Password = this.valuechange.Password + 1;
    }
  }

  // =================================================
  DemographicPhoneFormat1() {
    this.UserPhone1 = this.general.converPhoneGoogleLib(this.UserPhone1);
  }
  // /////////////////////////////////////////////////////////////
  DemographicPhoneFormat2() {
    this.UserPhone2 = this.general.converPhoneGoogleLib(this.UserPhone2);
  }

  // ==========================================================

  openDialog() {
    if (this.popBool == true) {
      document.getElementById('cancelmodal').click();
    }
    else {
      document.getElementById('OpenModal1').click();
    }
  }

  closeAddUpdateModal() {
    document.getElementById('cancelmodal').click();
    document.getElementById('OpenModal1').click();
  }

  openDialog1() {
    if (this.popBool == true) {
      document.getElementById('cancelmodal1').click();
    }
    else {
      document.getElementById('OpenModal2').click();
    }
  }

  closeAddUpdateModal1() {
    document.getElementById('cancelmodal1').click();
    document.getElementById('OpenModal2').click();
  }
  //=================================== Tooltip ====================================//
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString()
        }, args.cell as HTMLTableCellElement);
      }
    }
  }

  ////////////////////////////////////////////////////////

  onResize(args) {

    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });
  }

  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].Users.Columns;
    let showcol = this.arraycol[0].Users.ShowColumns;
    let hidecol = this.arraycol[0].Users.HideColumns
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    if (this.grid != undefined) {
      this.grid.columns.forEach(col => {
        this.arraycol[0].Users.HideColumns.forEach(element => {
          if (col.headerText == element) {
            col.visible = false;
          }
        });
      });
      this.grid.hideColumns(hidecol);
      this.grid.pageSettings.pageSize = this.arraycol[0].Users.Pagesize;
      this.ColumnArray.forEach(element => {



        if (element.column == 'Name') {

          const column = this.grid.getColumnByField('name'); // get the JSON object of the column corresponding to the field name
          column.headerText = element.column;
          column.width = element.width;

          this.grid.refreshHeader();
        }
        if (element.column == 'User Role') {

          const column1 = this.grid.getColumnByField('userRole'); // get the JSON object of the column corresponding to the field name
          column1.headerText = element.column;
          column1.width = element.width;

          this.grid.refreshHeader();
        }
        if (element.column == 'User Status') {

          const column2 = this.grid.getColumnByField('statusLname'); // get the JSON object of the column corresponding to the field name
          column2.headerText = element.column;
          column2.width = element.width;

          this.grid.refreshHeader();
        }
        if (element.column == 'Phone') {

          const column3 = this.grid.getColumnByField('phone1'); // get the JSON object of the column corresponding to the field name
          column3.headerText = element.column;
          column3.width = element.width;

          this.grid.refreshHeader();
        }
        if (element.column == 'Email') {

          const column4 = this.grid.getColumnByField('email'); // get the JSON object of the column corresponding to the field name
          column4.headerText = element.column;
          column4.width = element.width;

          this.grid.refreshHeader();
        }
        else if (element.column == 'Actions') {

          const column5 = this.grid.getColumnByUid('action'); // get the JSON object of the column corresponding to the field name
          column5.headerText = element.column;
          column5.width = element.width;
          this.grid.refreshHeader();

        }
      });
    }
  }
  SaveColumnwidth() {
    this.arraycol[0].Users.Columns = this.ColumnArray;
    this.arraycol[0].Users.Pagesize = this.grid.pageSettings.pageSize;

    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id.toString();

    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.httpService.savecolumwidth(this.columnchange).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    });
  }

  /// Get Location function//
  getLocation() {
    if (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '' && this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      this.httpService.getLocation().pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
        this.locationList = data;

      })
    }

  }
  isalphanumbericonly(event) {
    if (!(this.global.isdigit(event.key) || this.global.isalpha(event.key))) {
      event.preventDefault();
    }
  }
  ////Location for other user////
  getLocationotherUser() {
    let params = new URLSearchParams();
    let url = "api/User/GetuseLocationdropdown?";

    let myParams = new URLSearchParams();
    myParams.append("Code", "LOCATION_STATUS");
    this.http.get(url + myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {

      this.locationList = data;
      this.locationList.forEach(element => {
        element.Key = element.Key;
      });


    })
  }
  //......................................................RoleTypeChange.........................................................
  RoleTypeChange() {

    if (this.RoleType == "SuperAdminRole") {
      this.isSuperAdmin = true;
      this.isInternalRole = false;
    }
    else if (this.RoleType == "Agencyadmin") {
      this.isInternalRole = false;
      this.isSuperAdmin = false;
    }

    else if (this.RoleType == "Global") {
      this.isInternalRole = false;
      this.isSuperAdmin = false;
    }

    else if (this.RoleType == "Internal") {
      this.isInternalRole = true;
      this.isSuperAdmin = false;
    }

  }
  //......................................................RoleTypeChange Update.........................................................
  RoleTypeChangeUpdate() {

    if (this.RoleTypeUpdate == "SuperAdminRole") {
      this.isSuperAdmin = true;
      this.isInternalRole = false;
    }
    else if (this.RoleTypeUpdate == "Agencyadmin") {
      this.isInternalRole = false;
      this.isSuperAdmin = false;
    }

    else if (this.RoleTypeUpdate == "Global") {
      this.isInternalRole = false;
      this.isSuperAdmin = false;
    }

    else if (this.RoleTypeUpdate == "Internal") {
      this.isInternalRole = true;
      this.isSuperAdmin = false;
    }
    this.initData();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
